import React from 'react'
import { css } from '@emotion/core'
import { number, shape, string } from 'prop-types'
import { useOverlay } from '@fs/zion-ui'
import LeaderboardOverlay from '../LeaderboardOverlay'
import { SimpleLandingPageBackground } from '../LandingPageBackground/index'
import StreaksOverlay from '../Streaks/StreaksOverlay'
import { useGetStreaks } from '../../hooks'
import topicsData from '../topics'

import LargeStoryHeaderContent from './LargeStoryHeaderContent'
import SmallStoryHeaderContent from './SmallStoryHeaderContent'

export default function StoryBanner({ isSmallScreen, activePersonId, onActivePersonIdChange, points, user, ...rest }) {
  const overlay = useOverlay()
  const streaksOverlay = useOverlay()
  const { data: getStreaksState } = useGetStreaks(true)

  const topBannerCss = css`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    padding: ${isSmallScreen ? '0px' : '20px'} 20px 0px 20px;
  `

  // Derive streak values directly from getStreaksState
  const endOfStreak = getStreaksState?.endOfWeek
  const totalActivities = getStreaksState?.totalActivities ?? 0
  const streakCount = getStreaksState?.streakCount ?? 0
  const isStreakCurrent = getStreaksState?.isCurrent ?? false

  return (
    <div
      css={topBannerCss}
      style={{
        paddingBottom: isSmallScreen ? '0px' : '20px',
        borderEndStartRadius: '20px',
        borderEndEndRadius: '20px',
      }}
    >
      <SimpleLandingPageBackground height={rest?.height} fillColors={topicsData.story.simpleFillColors} />

      {!isSmallScreen ? (
        <LargeStoryHeaderContent
          cisId={user.cisId}
          isStreakCurrent={isStreakCurrent}
          streakCount={streakCount}
          points={points}
          activePersonId={activePersonId}
          onStreakClick={streaksOverlay.handleClick}
          onPointsClick={overlay.handleClick}
          onActivePersonIdChange={onActivePersonIdChange}
        />
      ) : (
        <SmallStoryHeaderContent
          cisId={user.cisId}
          isStreakCurrent={isStreakCurrent}
          streakCount={streakCount}
          points={points}
          activePersonId={activePersonId}
          onStreakClick={streaksOverlay.handleClick}
          onPointsClick={overlay.handleClick}
          onActivePersonIdChange={onActivePersonIdChange}
        />
      )}
      <LeaderboardOverlay overlay={overlay} />
      <StreaksOverlay
        streakCount={streakCount}
        endOfStreak={endOfStreak}
        overlay={streaksOverlay}
        totalActivities={totalActivities}
        isCurrent={isStreakCurrent}
      />
    </div>
  )
}

StoryBanner.propTypes = {
  points: number,
  height: string,
  rest: shape({
    bgref: string.isRequired,
  }),
}
